module.exports = __webpack_public_path__ + "static/media/skjule.5706cf58.m4a";